import dayjs from 'dayjs';
import { ExportToCsv } from 'export-to-csv-fix-source-map';
import _ from 'lodash';
import { useCallback } from 'react';
import { useAppSelector } from '../../../app/hooks';
import { BlueberryFeatures } from '../../../services/data/impl/cube/cubeSlice';
import { useBlock } from '../../../services/entities/hooks/useBlock';
import { useGetScanByIdQuery } from '../../../services/entities/impl/blfApi/endpoints/scans';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { useBlueberryEstimatedCountRowsideStackBar } from '../../scanDataApi/hooks/useBlueberryEstimatedCountRowsideStackBar';
import { useBlueberryFlowerFeatures } from '../../scanDataApi/hooks/useBlueberryFlowerFeatures';
import { ScanDataEnum } from '../../scanDataApi/scanDataDefinitions';
import { orderBlueberriesByRipenessOrder } from '../../scanDataApi/scanDataUtils';
import { selectCurrBlockID, selectCurrScanID } from '../../select/selectSlice';
export const useExportRowsideEstimatedCountsChart = () => {
  const { t } = useTranslation();
  const { data, error, isLoading } = useBlueberryEstimatedCountRowsideStackBar({
    activeFilters: {
      currBlueberryClass: false,
    },
  });
  const flowerFeatures = useBlueberryFlowerFeatures();

  const currBlockID = useAppSelector(selectCurrBlockID);
  const currScanID = useAppSelector(selectCurrScanID);
  const { block: currBlock } = useBlock(currBlockID);
  const { currentData: currScan } = useGetScanByIdQuery(currScanID);

  const exportCSV = useCallback(() => {
    if (isLoading || error || !data) return;

    const featuresRipenessOrder = orderBlueberriesByRipenessOrder({
      arrayToOrder: [...flowerFeatures, ...BlueberryFeatures],
    });

    const columns = [
      t('Rowside Number'),
      t('View Direction'),
      ...featuresRipenessOrder.map((el) => t(el)),
      t('Total'),
    ];

    const exportData = data.rawData?.map((row) =>
      _.omit(row, [ScanDataEnum.rowside_id])
    );
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useTextFile: false,
      useBom: true,
      filename: `Block-${currBlock?.name}-${dayjs(currScan?.scanDate).format(
        'YYYY-MM-DD'
      )}-Rowside-Estimated-Count`,
      headers: columns,
    };
    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(exportData);
  }, [
    isLoading,
    error,
    data,
    flowerFeatures,
    t,
    currBlock?.name,
    currScan?.scanDate,
  ]);

  return {
    exportCSV,
  };
};
